import type { ColorMap, ExtendedColor } from "@pdfking/renderer-api"
import { RecordMap, Reduce } from "@pdfking/tfunc"

import type { ColorHook, Hook } from "#internal"

import { ColorList } from "../../../data/ColorList"

const ApplyColorHooks = (hooks: ColorHook[], color: ExtendedColor): ExtendedColor =>
  Reduce((current, hook) => hook(current), hooks, color)

// Resolve the base `ColorList` through a job's `color_processor` hooks (e.g.
// `bn` for black-only). Only imposition carries these; prepress passes `[]` and
// gets the list back untouched.
export const BuildColorMap = (processors: Hook[]): ColorMap => {
  const hooks = processors.flatMap(p => (p.color_processor ? [p.color_processor] : []))
  return RecordMap(c => ApplyColorHooks(hooks, c), ColorList)
}
